import { tailorSchemas } from '../../../tailor'
import { books1Fit } from './section-fit'
import { lightings1BaseSchemas } from '../../lightings/lightings-1/builder-schemas'
import { catalogueSchemas } from './sections/catalogue'
import { schema as footerSchema } from './sections/footer/footer.schema'
import { schema as headerSchema } from './sections/header/header.schema'
import { homeSchemas } from './sections/home'
import { purchaseSchemas } from './sections/purchase'

/**
 * Pathok (books-1), the Cares storefront design. It renders the shared section types with its own
 * markup (storefront-nuxt `sections/<type>/themes/books-1.vue`) and adds Cares-only home sections; the
 * shared schemas keep stored data portable between themes.
 */
export const books1Schemas = tailorSchemas({
  ...lightings1BaseSchemas,
  componentSchemas: {
    ...lightings1BaseSchemas.componentSchemas,
    ...homeSchemas,
    ...catalogueSchemas,
    ...purchaseSchemas,
  },
  headerSchema,
  footerSchema,
}, books1Fit)
